import {
  isFormulaEntry,
  isGroupedEntry,
  isPropertyEntry,
  isSavedMetricEntry,
  QuerySuperEntry,
} from 'common/query-builder/query-entry-section/types';

// Starting forward value for new flows entry rows is 3
export const STARTING_FORWARD_VALUE = 3;
export const OVERRIDE_STARTING_FORWARD_VALUE = 0;

export function hasEventValue(entry: QuerySuperEntry) {
  // When adding a new row for filter/segment, the entry will be initialized to null. For other entry types,
  // a placeholder entry is used with `value` field null.
  if (isPropertyEntry(entry)) {
    return !!entry.event;
  } else if (isGroupedEntry(entry)) {
    // Grouped entries are managed by a sub- query-entry-section and always have an event.
    return true;
  } else if (isFormulaEntry(entry)) {
    return false;
  } else if (isSavedMetricEntry(entry)) {
    return false;
  } else {
    return !!entry.event?.value;
  }
}
